import React from "react";
import { withRouter, Redirect } from "react-router-dom";
import { Query } from "react-apollo";
import gql from "graphql-tag";

import { css } from "glamor";
import { Dropdown, Icon, Row, Col, notification } from "antd";

import { switchUser } from "../../api/apollo";
import WithAuth from "../WithAuth";
import { withApolloState } from "../../util/apollo";
import { PERMISSION_DENIED_PATH } from "../../config";
import TopBarLogo from "./TopBarLogo";
import TopBarMenu from "./TopBarMenu";
import AuthActivity from "./AuthActivity";

const styles = {
    menu: css({
        lineHeight: "64px !important",
        float: "right",
    }),
    dropdownMenu: css({
        textAlign: "right",
    }),
};

class TopBar extends React.Component {
    switchUser = async id => {
        this.handlePreSwitchUser();
        await switchUser(id);
    };

    switchUserBack = async () => {
        this.handlePreSwitchUser();
        await switchUser();
    };

    handlePreSwitchUser = () => {
        notification.open({
            message: "Switching your user ...",
            icon: <Icon type="user" />,
            duration: 2,
        });
    };

    render() {
        return (
            <Query
                fetchPolicy="network-only"
                query={gql`
                    query TopBarQuery {
                        clientConfig {
                            hooks(hookType: 1) {
                                type
                                label
                                link
                                priority
                            }
                            logo
                            enabledFeatures
                        }
                        permissions {
                            task {
                                canViewAllOpen
                                canAssign
                                canEditDispositionComments
                            }
                            flowAccess
                        }
                        users {
                            id
                            username
                            authActivity(action: 1) {
                                requestInfo {
                                    ip
                                    userAgent
                                }
                                timestamp
                            }
                        }
                    }
                `}
            >
                {withApolloState(({ data }) => (
                    <Row>
                        {!data.permissions.flowAccess &&
                            this.props.location.pathname !==
                                PERMISSION_DENIED_PATH && (
                                <Redirect to={PERMISSION_DENIED_PATH} />
                            )}
                        <Col xs={{ span: 3 }} lg={{ span: 3 }}>
                            <TopBarLogo props={data.clientConfig} />
                        </Col>

                        <Col xs={{ span: 9 }} lg={{ span: 9 }}>
                            <AuthActivity
                                auth={this.props.auth}
                                users={data.users}
                            />
                        </Col>

                        <Col xs={{ span: 0 }} lg={{ span: 12 }}>
                            <TopBarMenu
                                menuItems={this.props.menuItems}
                                auth={{ ...this.props.auth }}
                                userlist={data}
                                config={data.clientConfig}
                                switchUserHandler={this.switchUser}
                                switchUserBackHandler={this.switchUserBack}
                                currentLocation={this.props.location.pathname}
                                className={`${styles.menu}`}
                            />
                        </Col>

                        <Col
                            className={`${styles.dropdownMenu}`}
                            xs={{ span: 12 }}
                            lg={{ span: 0 }}
                        >
                            <Dropdown
                                overlay={
                                    <TopBarMenu
                                        config={data.clientConfig}
                                        menuItems={this.props.menuItems}
                                        auth={{ ...this.props.auth }}
                                        userlist={data}
                                        switchUserHandler={this.switchUser}
                                        switchUserBackHandler={
                                            this.switchUserBack
                                        }
                                    />
                                }
                            >
                                <a href="#">
                                    <Icon type="appstore-o" /> MENU
                                </a>
                            </Dropdown>
                        </Col>
                    </Row>
                ))}
            </Query>
        );
    }
}

export default withRouter(WithAuth(TopBar));
